var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTwitterPrimary(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 63"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 128",
    style: {
      fill: "none",
      opacity: 0.502
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.945 6.3A8.185 8.185 0 0 0 20 4.174a8.563 8.563 0 0 1-2.362.648 4.078 4.078 0 0 0 1.8-2.266 8.2 8.2 0 0 1-2.6.993 4.1 4.1 0 0 0-7.093 2.8 4.222 4.222 0 0 0 .1.935A11.608 11.608 0 0 1 1.393 3a4.1 4.1 0 0 0 1.26 5.48A4.053 4.053 0 0 1 .8 7.972v.045a4.119 4.119 0 0 0 3.285 4.029 4.077 4.077 0 0 1-1.075.135 3.619 3.619 0 0 1-.776-.07 4.141 4.141 0 0 0 3.831 2.857 8.242 8.242 0 0 1-5.084 1.748A7.755 7.755 0 0 1 0 16.66a11.547 11.547 0 0 0 6.29 1.84A11.59 11.59 0 0 0 17.945 6.3z",
    transform: "translate(2 1.625)",
    style: {
      fill: "#0222ba"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitterPrimary);
export default __webpack_public_path__ + "static/media/icon-twitter-primary.c670fb45b18d289df31f77ba39615d57.svg";
export { ForwardRef as ReactComponent };